module.exports = __webpack_public_path__ + "static/media/profile.fd258188.png";